import styled from "styled-components";

export const ChartWrapper = styled.div`
  background-color: var(--theme-color-secondary);
  border-radius: 1rem;
  padding: 14px;
  overflow: hidden;
`;

export const ChartContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-bottom: 30px;
  height: 260px;

  @media only screen and (max-width: 600px) {
    height: 200px;
  }
`;